/**
 * @file 任务配置页面空状态
 * @author sunyingying01
 */

import React, {useCallback} from 'react';
import {observer} from 'mobx-react-lite';
import {Button} from 'antd';
import cx from 'classnames';
import {PlusOutlined} from '@ant-design/icons';
import {InitialHeader} from '@/modules/InitialModules';
import {EditModal} from '@/modules/SiderModules/Jobs/EditModal';
import {MigrationRestrictTip} from '@/modules/MigrationModules';
import {JobStore} from '@/stores';
import EmptySvg from '@/assets/icons/empty.svg';
import styles from './index.module.less';

interface IInitialEmptyPage {
    store: IPageStore;
}

const InitialEmptyPage: React.FC<IInitialEmptyPage> = observer(props => {
    const {store} = props;
    const {projectsListStore, rootStore} = store;
    const {jobsListStore} = projectsListStore;
    const {userStore} = rootStore;
    // 创建任务
    const handleCreateJob = useCallback(
        () => {
            const job = new JobStore();
            jobsListStore.setCurrentJobDetail(job);
            job.updateShowEditModal(true);
            job.updateEditJobModalStatus('create');
        },
        [jobsListStore]
    );


    return (
        <div className={cx(
            styles.initialWrapper, {[styles.collapsedInitialWrapper]: rootStore.siderNavigationStore.collapsed})
        }
        >
            <InitialHeader store={store} onChangeJob={null} isEmpty />
            <div className={styles.emptyInitial}>
                <div className={styles.emptyInitialContent}>
                    <div className={styles.emptyImage}>
                        <EmptySvg />
                    </div>
                    暂未创建任何任务
                </div>
                <div>
                    <MigrationRestrictTip enabled={userStore.isMigrationRestricted} placement="top">
                        <Button
                            type="primary"
                            style={{width: '106px'}}
                            disabled={userStore.isMigrationRestricted}
                            onClick={handleCreateJob}
                        >
                            <PlusOutlined style={{fontSize: 16}} />新任务
                        </Button>
                    </MigrationRestrictTip>
                </div>
            </div>
            <EditModal
                store={store}
                jobStore={jobsListStore.currentJobDetail}
            />
        </div>
    );
});

export default InitialEmptyPage;
